import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Dropdown,
  Menu,
  Button,
  Dimmer,
  Loader,
  Label,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { RX_EMAIL } from '@mhub/web-validations/dist/constants/index';

import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import NavBar from '../../../components/NavBar';
import { editRoutes } from '../navigations';
import * as endpoints from '../../../constants/apiEndpoints';

import InviteLawyerForm from '../../modals/InviteLawyerForm';
import LawyersList from '../../modals/LawyersList';
import DeleteConfirm from '../../modals/DeleteConfirm';

import LawyerItem from '../../../components/LawyerItem';
import ProjectPanelLawyers from '../../../components/ProjectPanelLawyers';
import { fetchAPI, fetchM } from '../../../actions/fetchM';
import config from '../../../../config';

class PanelLawyers extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    id: PropTypes.string,
    data: PropTypes.shape({
      loanTrackerProjectID: PropTypes.number,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    onCheck: PropTypes.func,
    auth: PropTypes.shape({
      company: PropTypes.object,
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const data = props.data || [];
    const loading = props.loading;
    const menuIsTab = window.innerWidth <= 590;
    return {
      data,
      loading,
      menuIsTab,
    };
  }
  constructor(props) {
    super(props);
    const state = PanelLawyers.getPropsToState(props);
    this.state = {
      ...state,
      oriData: [],
      showInviteLawyer: false,
      showAddLawyer: false,
      showDeleteConfirm: false,
      selectedLawyer: null,
      panelLawyers: [],
      hasChanges: false,
      updateProjectLoading: false,
    };
    this.list = null;
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = PanelLawyers.getPropsToState(nextProps);
    this.setState(state);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setLoading = (loading = false) => (new Promise((res) => {
    this.setState({ loading }, res);
  }))
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleShowInviteLawyer = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showInviteLawyer: true,
    });
  }
  handleCloseInviteLawyer = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showInviteLawyer: false,
    }, () => {
      if (this.inviteForm) {
        this.inviteForm.resetData();
      }
    });
  }
  handleConfirmInviteLawyer = () => {
    this.setState({
      showInviteLawyer: false,
    }, () => {
      if (this.inviteForm) {
        this.inviteForm.resetData();
      }
      if (this.list) {
        this.list.refresh();
      }
    });
  }
  addPanelLawyer = async (lawyerIDs) => {
    await this.setComponentState({ loading: true });
    const { store } = this.context;
    const { data } = this.props;
    if (!data.loanTrackerProjectID) {
      await store.dispatch(flashErrorMessage({ message: 'This project is not linked in loan tracker.' }));
      return;
    }
    const body = {
      lawyer_ids: lawyerIDs,
      project_name: data.name,
    };
    try {
      await store.dispatch(fetchAPI('lawyerAPI', endpoints.PANEL_LAWYERS(data.loanTrackerProjectID), body, 'put', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }

    await store.dispatch(flashSuccessMessage({ header: 'Add Success', message: 'Panel lawyer(s) successfully added.' }));
    await this.setLoading(false);

    if (this.list) {
      this.list.refresh();
    }
  }
  removePanelLawyer = async () => {
    await this.setComponentState({ loading: true });
    const { store } = this.context;
    const { data } = this.props;
    if (!data.loanTrackerProjectID) {
      await store.dispatch(flashErrorMessage({ message: 'This project is not linked in loan tracker.' }));
      return;
    }
    const { selectedLawyer } = this.state;
    try {
      await store.dispatch(fetchAPI('lawyerAPI', endpoints.PANEL_LAWYER(data.loanTrackerProjectID, selectedLawyer.lawyer_id), null, 'del', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }

    await store.dispatch(flashSuccessMessage({ header: 'Remove Success', message: 'Panel lawyer successfully removed.' }));
    await this.setComponentState({ selectedLawyer: null, loading: false });
    if (this.list) {
      this.list.refresh();
    }
  }
  resendInvitation = async (invitation) => {
    await this.setLoading(true);
    const { store } = this.context;
    if (invitation.updated_at && moment().isAfter(moment(invitation.updated_at).add(moment.duration(1, 'day')))) {
      await store.dispatch(flashErrorMessage({ message: 'Invitation already resend. Please try again later.' }));
      return;
    }
    try {
      await store.dispatch(fetchAPI('lawyerAPI', endpoints.LAWYER_RESEND_INVITE(invitation.id), null, 'put', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }

    await store.dispatch(flashSuccessMessage({ header: 'Resend Success', message: 'Invitation successfully resend.' }));
    await this.setLoading(false);
    if (this.list) {
      this.list.refresh();
    }
  }
  async updateProject() {
    const { store } = this.context;
    const { data } = this.state;
    await this.setComponentState({ loading: true, updateProjectLoading: true });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${data.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(data),
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
    }
    const project = await res.json();
    await this.setComponentState({ loading: false, hasChanges: false, updateProjectLoading: false }, () => {
      this.handleResetCheck();
    });
    store.dispatch(flashSuccessMessage({ header: 'Update Success', message: `${project.name} successfully updated` }));
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  handleShowAddLawyer = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAddLawyer: true,
    });
  }
  handleCloseAddLawyer = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAddLawyer: false,
    });
  }
  handleAddLawyer = (e, selected) => {
    if (e) { e.preventDefault(); }
    this.setState({ showAddLawyer: false }, () => {
      this.addPanelLawyer(selected);
    });
  }
  handleShowDeleteConfirm = (e, selectedLawyer) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showDeleteConfirm: true,
      selectedLawyer,
    });
  }
  handleCloseDeleteConfirm = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showDeleteConfirm: false,
      selectedLawyer: null,
    });
  }
  handleDeleteLawyer = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({ showDeleteConfirm: false }, () => {
      this.removePanelLawyer();
    });
  }
  handleGetPanelLawyers = (panelLawyers) => {
    this.setState({ panelLawyers });
  }
  handleResend = (e, item) => {
    this.resendInvitation(item);
  }
  handleSetAutoAssignLawyerStatus = (autoAssignStatus) => {
    const { data } = this.state;
    data.autoAssignLawyerStatus = autoAssignStatus;
    this.setState({ data, hasChanges: true });
  }
  handleSetSettingsChanges = (changesData) => {
    const { data } = this.state;
    data[changesData.name] = changesData.value;
    this.setState({ data, hasChanges: true });
  }
  handleSetLawyerUpdateEmails = (name, value) => {
    const { data } = this.state;
    const { store } = this.context;
    data[name] = value;
    const r = new RegExp(RX_EMAIL, 'i');
    if (value.some(v => !r.test(v))) {
      store.dispatch(flashErrorMessage({ message: 'Invalid email address' }));
      return;
    }
    if (data[name] &&
      data[name].some(eml => value.some(v => eml.text === v))) {
      store.dispatch(flashErrorMessage({ message: 'Duplicate email address' }));
      return;
    }
    this.setState({ data, hasChanges: true });
  }
  handleUpdate = (e) => {
    if (e) { e.preventDefault(); }
    this.updateProject();
  }
  render() {
    const { auth, id, location, data } = this.props;
    const { pathname } = location;
    const companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const links = editRoutes(id, true, isMalaysia, companyServiceID);
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          rightNav={
            <Menu.Item fitted>
              <Button
                onClick={this.handleUpdate}
                disabled={this.state.loading || !this.state.hasChanges}
                positive
                content="Save"
              />
            </Menu.Item>
          }
        />
        <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
          <Loader inline="centered">Loading</Loader>
        </Dimmer>
        <LawyersList
          open={this.state.showAddLawyer}
          onClose={this.handleCloseAddLawyer}
          onItemClick={this.handleAddLawyer}
          onConfirm={this.handleAddLawyer}
          onCheck={lawyer => lawyer.panels && lawyer.panels.split(',').some(pid => pid === `${data.loanTrackerProjectID}`)}
          selected={this.state.panelLawyers}
          loanTrackerProjectID={data ? data.loanTrackerProjectID : 0}
        />
        <DeleteConfirm
          open={this.state.showDeleteConfirm}
          onClose={this.handleCloseDeleteConfirm}
          onConfirm={this.handleDeleteLawyer}
          headerNode="Confirm remove panel lawyer?"
          content={
            <p>Are you sure to remove <strong>{this.state.selectedLawyer ? this.state.selectedLawyer.lawyer_name : ''}</strong> from panel lawyers?</p>
          }
        />
        <InviteLawyerForm
          company={this.props.auth.company}
          ref={(ref) => { this.inviteForm = ref; }}
          open={this.state.showInviteLawyer}
          onClose={this.handleCloseInviteLawyer}
          onConfirm={this.handleConfirmInviteLawyer}
          loanTrackerProjectID={data ? data.loanTrackerProjectID : 0}
          projectName={data ? data.name : ''}
          setLoading={this.setLoading}
        />
        <ProjectPanelLawyers
          ref={(ref) => { this.list = ref; }}
          loading={this.state.loading}
          loanTrackerProjectID={data ? data.loanTrackerProjectID : 0}
          onChange={this.handleGetPanelLawyers}
          onStatusChange={this.handleSetAutoAssignLawyerStatus}
          onSettingsChange={this.handleSetSettingsChanges}
          onEmailsChange={this.handleSetLawyerUpdateEmails}
          project={this.state.data}
          allowLawyerAssignWithoutIC={this.state.data && this.state.data.allowLawyerAssignWithoutIC}
          updateProjectLoading={this.state.updateProjectLoading}
          panelLawyerSettings
          buttonNode={
            <div>
              <Button
                onClick={this.handleShowAddLawyer}
                disabled={this.state.loading}
                primary
                content="Add"
              />
            </div>
          }
          emptyNode={(tab) => {
            if (tab === 'panel') {
              return (
                <div>
                  <p>No panel lawyer is added.</p>
                  <p><a type="button" onClick={this.handleShowAddLawyer}>Add Lawyer</a> as Panel Lawyer now</p>
                </div>
              );
            }
            return <p>No invited lawyer found.</p>;
          }}
          itemNode={(item, idx, currentTab) => (
            <LawyerItem
              item={item}
              headerNode={currentTab === 'invited' ? (
                <Label>Pending Registration</Label>
              ) : null}
              disabled={this.state.loading}
              rightComponentTextAlign="right"
              rightComponent={
                currentTab === 'invited' ? (
                  <Button
                    floated="right"
                    onClick={e => this.handleResend(e, item)}
                    primary
                    content="Resend"
                    compact
                    disabled={this.state.loading || (item.updated_at && moment().isAfter(moment(item.updated_at).add(moment.duration(1, 'day'))))}
                  />
                ) : (
                  <Button
                    floated="right"
                    onClick={e => this.handleShowDeleteConfirm(e, item)}
                    negative
                    icon="trash"
                    compact
                    disabled={this.state.loading}
                  />
                )
              }
            />
          )}
        />
      </Container>
    );
  }
}

export default connect(PanelLawyers.mapStateToProps)(PanelLawyers);



// WEBPACK FOOTER //
// ./src/containers/Project/PanelLawyers/index.jsx